<form [formGroup]="frm" (ngSubmit)="onSubmit(frm)">
  <div class="p-fluid">
    <div class="p-g" style="padding: 1em;">
      <div class="p-g-12" >
        <span class="p-float-label">
          <input pInputText style="width: 100%" id="owner" type="text" formControlName="name">
          <label for="newName">Название</label>
        </span>
        <p-message severity="error" *ngIf="frm.controls['name'].hasError('required')" text="Обязательное поле">
        </p-message>
      </div>
      <div class="p-g-12">
        <span class="p-float-label">
          <textarea style="width: 100%" type="text" rows="2" pInputTextarea formControlName="desc"></textarea>
          <label for="newName">Описание</label>
        </span>
      </div>
    </div>
  </div>
  <hr>
  <p-footer>
    <button pButton class="p-button-success" icon="pi pi-check" label="Сохранить" type="submit"
    [disabled]="!frm.valid"></button>
<button pButton type="button" icon="pi pi-ban" class="p-button-secondary" label="Закрыть"
    (click)="onCancel()"></button>
  </p-footer>
</form>
